import {
  TeaserConfig as ITeaserConfig
} from 'services/api-service'

export class TeaserConfig implements ITeaserConfig {
  constructor(config: ITeaserConfig) {
    this.excludeComments = config.excludeComments
    this.excludeQa = config.excludeQa
    this.excludeReviews = config.excludeReviews
    this.showAvgRating = config.showAvgRating
    this.widgetDivId = config.widgetDivId
  }

  excludeComments: boolean
  excludeQa: boolean
  excludeReviews: boolean
  showAvgRating: boolean
  widgetDivId: string
}

let defaultConfig: ITeaserConfig = {}
export function loadConfig(config: ITeaserConfig) {
  defaultConfig = new TeaserConfig(config)
}
export { defaultConfig as default }
